import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { MarvTagComponent } from '@marv/components';
import { MarvColor } from '@marv/types';
import { environment } from '@app/environment';
import { MissionTypeService, OperationService } from '@app/services';

export class TypeMissionLegend {
    code: string;
    name: string;
    color: MarvColor;
    disabled: boolean = false;
    constructor(code: string, name: string, color: MarvColor){
        this.code = code;
        this.name = name;
        this.color = color;
    }
}

@Component({
    selector: 'app-type-mission-legend',
    templateUrl: './legend.component.html',
    styleUrls: ['./legend.component.scss'],
    imports: [TranslatePipe, forwardRef(() => MarvTagComponent)]
})
export class TypeMissionLegendComponent  implements OnInit {

    @Input({alias : 'size', required : false}) sizeLegend: 'big'|'medium'|'small' = 'small';
    @Input({alias : 'isClickable', required : false}) isClickable: boolean = false;
    @Output() onClickTypeMission = new EventEmitter<TypeMissionLegend>();

    typesMissions: Array<TypeMissionLegend> = [];

    constructor(
        public missionTypeService: MissionTypeService
    ) { }

    ngOnInit() {
        let operationsTypesMissions = OperationService.Operations.map(o => o.typeOfMissionCode) || [];
        for(let t of environment.MISSIONS_TYPES){  
            if(operationsTypesMissions.indexOf(t.code) !== -1){
                this.typesMissions.push(new TypeMissionLegend(t.code, t.name, t.color));  
            }          
        }        
    }

    onClickTag($event: any, typeMission: TypeMissionLegend){
        if(this.isClickable){
            typeMission.disabled = !typeMission.disabled;
            this.onClickTypeMission.emit(typeMission);
        }
    }
}
